const STORAGE_KEY = 'pending-action';

export const PENDING_ACTION = Object.freeze({
  PARKING: 'parking',
  SHOW_TOAST: 'show-toast',
});

export const getPendingAction = (action) => {
  try {
    const storageItem = localStorage.getItem(STORAGE_KEY);
    if (!storageItem) {
      return null;
    }
    const pendingAction = JSON.parse(storageItem);
    return pendingAction.name === action ? pendingAction : null;
  } catch {
    return null;
  }
};

export const clearPendingAction = () => {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    // localStorage unavailable
  }
};

export const addPendingAction = (name, payload) => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ name, payload }));
  } catch {
    // localStorage unavailable
  }
};

export const firePendingAction = (action, callback) => {
  const pendingAction = getPendingAction(action);
  if (pendingAction) {
    if (callback(pendingAction.payload)) {
      clearPendingAction();
    }
  }
};
